import React, { useEffect, useState, useMemo } from "react";
import CommonDataTable from "../../components/CommonDataTable";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { fetchAdjustments } from "../../services/adjustment/adjustment";

const mapAdjustmentRows = (apiData = []) =>
    apiData.map((item) => {
        const h = item.AdjHeader || {};
        return {
            id: item._id,
            __raw: item,
            Warehouse: h.Warehouse ?? "",
            ItrnKey: h.ItrnKey ?? "",
            TranType: h.TranType ?? "",
            Adjustmentkey: h.Adjustmentkey ?? "",
            StorerKey: h.StorerKey ?? "",
            ReferenceNumber: h.ReferenceNumber ?? "",
            AdjustmentAddDate: h.AdjustmentAddDate ?? "",
            Notes: h.Notes ?? "",
            SourceType: h.SourceType ?? "",
            SourceKey: h.SourceKey ?? "",
            addwho: h.addwho ?? "",
            editwho: h.editwho ?? "",
        };
    });

const baseColumns = [
    { field: "Warehouse", headerName: "Warehouse", width: 120 },
    { field: "ItrnKey", headerName: "ITRN Key", width: 130 },
    { field: "TranType", headerName: "Tran Type", width: 100 },
    { field: "Adjustmentkey", headerName: "Adjustment Key", width: 140 },
    { field: "StorerKey", headerName: "Storer Key", width: 120 },
    { field: "ReferenceNumber", headerName: "Reference No", width: 130 },
    { field: "AdjustmentAddDate", headerName: "Add Date", width: 180 },
    { field: "Notes", headerName: "Notes", width: 150 },
    { field: "SourceType", headerName: "Source Type", width: 180 },
    { field: "SourceKey", headerName: "Source Key", width: 130 },
    { field: "addwho", headerName: "Added By", width: 140 },
    { field: "editwho", headerName: "Edited By", width: 140 },
];

export default function AdjustmentList({ onCreateClick, onView }) {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);

    const loadData = async (pageNo, size) => {
        try {
            const res = await fetchAdjustments(pageNo, size);
            const list = res?.data || [];
            const totalCount = res?.totalCount || 0;
            setRows(mapAdjustmentRows(list));
            setTotal(totalCount);
        } catch {
            setRows([]);
            setTotal(0);
        }
    };

    useEffect(() => {
        loadData(page, pageSize);
    }, [page, pageSize]);

    const handleDataRefresh = async (payload = {}) => {
        const p = payload.page !== undefined ? payload.page : page;
        const ps = payload.pageSize !== undefined ? payload.pageSize : pageSize;
        await loadData(p, ps);
    };

    const actionColumn = useMemo(
        () => ({
            field: "__actions",
            headerName: "",
            width: 50,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setMenuAnchorEl(e.currentTarget);
                        setMenuRow(params.row);
                    }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            ),
        }),
        []
    );

    return (
        <>
            <CommonDataTable
                id="adjustment-list"
                allPossibleColumns={[actionColumn, ...baseColumns]}
                initialVisible={[
                    "__actions",
                    ...baseColumns.map((c) => c.field),
                ]}
                initialRows={rows}
                rowCount={total}
                page={page}
                pageSize={pageSize}
                onPageChange={(newPage) => setPage(newPage)}
                onPageSizeChange={(newSize) => {
                    setPageSize(newSize);
                    setPage(0);
                }}
                height={500}
                showCreateButton
                // createButtonText="Add Adjustment"
                // onCreateClick={onCreateClick}
                checkboxSelection={true}
                enableImportButton={false}
                enableExportButton={false}
                forInventory={true}
                onDataRefresh={handleDataRefresh}
                readOnly
            />

            <Menu
                open={Boolean(menuAnchorEl)}
                anchorEl={menuAnchorEl}
                onClose={() => setMenuAnchorEl(null)}
            >
                <MenuItem
                    onClick={() => {
                        onView(menuRow.id);
                        setMenuAnchorEl(null);
                    }}
                >
                    <i className="bi bi-eye me-2" />
                    View
                </MenuItem>
            </Menu>
        </>
    );
}
